import React from "react";
import { IconButton, Tooltip } from "@material-ui/core";
import { apiBatchRequest, apiPost, clearCacheData } from "../../utils/api_service";
import camelcaseKeys from "camelcase-keys";
import moment from "moment";
import SaveIcon from "@material-ui/icons/Save";
import CancelIcon from "@material-ui/icons/Cancel";
import EditIcon from "@material-ui/icons/Edit";
import { ShowToast, toastType } from "../../utils/toast-service";
import DeleteIcon from "@material-ui/icons/Delete";
import { UpdateColumnWithConfiguration } from "../../utils/helper";
import { API_URL } from "../../constants/api";
import { GridTable } from "../common/Table/Table";
import ConfirmDialog from "../common/Dailogbox/confirmDailog";

export const buildingClassMasterColumns = [
  {
    name: "Building Class",
    key: "buildingClass",
    type: "Child",
    isRequired: true,
    isVisible: true,
    editConfig: {
      type: "TextField",
      isEditField: true,
      isAddField: true,
    },
  },
  {
    name: "ModifiedBy",
    key: "modifiedBy",
    type: "Child",
    isRequired: true,
    isVisible: true,
    editConfig: {
      type: "TextField",
      isEditField: false,
      isAddField: false,
    },
  },
  {
    name: "ModifiedOn",
    key: "modifiedDate",
    type: "Child",
    isRequired: true,
    isVisible: true,
    dataFormat: "Date",
    editConfig: {
      type: "TextField",
      isEditField: false,
      isAddField: false,
    },
  },
  {
    name: "Action",
    key: "buildingClassId",
    renderComponent: "renderActionColumn",
  },
];

export default class ConfigureBuildingClass extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      buildingMasterData: [],
      isInAddMode: false,
      reloadTable: false,
      selectedEditRowId: undefined,
      configuration: [],
      isInDeleteMode: false,
      updateMasterData: {
        buildingClassId: -1,
        buildingClass: null,
        modifiedBy: "",
        modifiedDate: moment().format("YYYY-MM-DD"),
      },
      showWarningMessage: false,
      confirmMessage: "",
      selectedMarketId: this.props.globalMarketId,
    };
  }

  componentDidMount() {
    this.getRequiredData();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.globalMarketId !== this.state.selectedMarketId) {
      this.getRequiredData(nextProps.globalMarketId);
      this.setState({ selectedMarketId: nextProps.globalMarketId });
    }
  }

  getRequiredData = () => {
    this._asyncRequest = apiBatchRequest([
      {
        url: API_URL.Master.buildingMasterData,
        key: "buildingMasterData",
        params: { businessLineId: 1 },
      },
    ])
      .then((buildingMasterData) => {
        this._asyncRequest = null;
        if (buildingMasterData.buildingMasterData.success === true) {
          this.setState({
            buildingMasterData:
              camelcaseKeys(buildingMasterData.buildingMasterData.data) || [],
            configuration:
              camelcaseKeys(
                buildingMasterData.buildingMasterData.configuration
              ) || [],
            reloadTable: true,
          });
          this.forceUpdate();
        } else {
          ShowToast(
            "Something went wrong",
            toastType.ERROR,
            5000,
            500,
            "Server error"
          );
        }
      })
      .catch(() => {
        this._asyncRequest = null;
      });
  };

  cancelAddMode = () => {
    this.setState({
      selectedEditRowId: undefined,
      isInAddMode: false,
      updateMasterData: undefined,
    });
  };

  cancelEditMode = () => {
    this.setState({
      selectedEditRowId: undefined,
      isInAddMode: false,
      updateMasterData: undefined,
    });
    //this.getRequiredData();
  };

  updateRecord = () => {
    const newParam = this.state.updateMasterData;
    if (!this.isValidForm(newParam)) {
      return;
    }
    // this.state.isInDeleteMode ? newParam.statusId = 0 : newParam.statusId = newParam.statusId;
    apiPost({
      url: API_URL.Master.UpdateBuildingClassDetail,
      params: { businessLineId: 1 },
      postBody: newParam,
    }).then(({ data: response }) => {
      if (response.success === true) {
        ShowToast("Record updated successfully.", toastType.SUCCESS, 5000, 500);

        clearCacheData(
          API_URL.Master.buildingMasterData +
          '{"businessLineId":1,"marketId":"' + this.state.selectedMarketId + '"}'
        );

        this.setState({
          updateData: undefined,
          selectedEditRowId: undefined,
          reloadTable: !this.state.reloadTable,
          isInAddMode: false,
          showWarningMessage: false,
          confirmMessage: "",
        });
        this.getRequiredData();
        this.forceUpdate();
      } else {
        ShowToast(response.message, toastType.ERROR, 5000, 5000);
      }
    });
  };

  deleteRecord = (cellInfo) => {
    this.setState({
      showWarningMessage: true,
      confirmMessage: "Do you want to delete this record ?",
      updateMasterData: cellInfo,
    });
  };

  onClickHandle(e) {
    if (e) {
      this.setState(
        {
          isInDeleteMode: true,
          reloadTable: !this.state.reloadTable,
        },
        () => {
          this.forceUpdate();
        }
      );
      const newParam = this.state.updateMasterData;
      newParam.statusId = 0;
      apiPost({
        url: API_URL.Master.UpdateBuildingClassDetail,
        params: { businessLineId: 1 },
        postBody: newParam,
      }).then(({ data: response }) => {
        if (response.success === true) {
          ShowToast(
            "Record deleted successfully.",
            toastType.SUCCESS,
            5000,
            500
          );

          this.setState({
            updateData: undefined,
            selectedEditRowId: undefined,
            reloadTable: !this.state.reloadTable,
            isInAddMode: false,
            showWarningMessage: false,
            confirmMessage: "",
          });
          this.getRequiredData();
          this.forceUpdate();
        } else {
          ShowToast(response.message, toastType.ERROR, 5000, 5000);
        }
      });
    } else {
      this.setState({
        showWarningMessage: false,
        confirmMessage: "",
      });
    }
  }

  isValidForm = (updateMasterData) => {
    const buildingClass = updateMasterData.buildingClass;

    // Validate building class field 
    if (!buildingClass || buildingClass.toString().trim().length === 0) {
      ShowToast("Building Class is required.", toastType.ERROR, 5000, 500);
      return false;
    }

    return true;
  };

  saveUpdatedRecord = () => {
    const newParam = this.state.updateMasterData;
    if (!this.isValidForm(newParam)) {
      return;
    }
    apiPost({
      url: API_URL.Master.AddBuildingClassDetail,
      params: { businessLineId: 1 },
      postBody: newParam,
    }).then(({ data: response }) => {
      if (response.success === true) {
        ShowToast(
          this.state.isInAddMode
            ? "Record added successfully."
            : "Record updated successfully.",
          toastType.SUCCESS,
          5000,
          500
        );

        clearCacheData(
          API_URL.Master.buildingMasterData +
          '{"businessLineId":1,"marketId":"' + this.state.selectedMarketId + '"}'
        );

        this.setState({
          updateData: undefined,
          selectedEditRowId: undefined,
          reloadTable: !this.state.reloadTable,
          isInAddMode: false,
          showWarningMessage: false,
          confirmMessage: "",
        });
        this.getRequiredData();
        this.forceUpdate();
      } else {
        ShowToast(response.message, toastType.ERROR, 5000, 5000);
      }
    });
  };

  renderActionColumn = (cellInfo, key, isInAddMode) => {
    return (
      <>
        {this.state.selectedEditRowId !== undefined &&
          cellInfo.buildingClassId === this.state.selectedEditRowId.value ? (
          <>
            <Tooltip title="Save Record">
              <IconButton
                aria-label={"refreshData"}
                size="small"
                onClick={() => { }}
              >
                <SaveIcon
                  fontSize="small"
                  size="small"
                  onClick={
                    this.state.isInAddMode
                      ? this.saveUpdatedRecord
                      : this.updateRecord
                  }
                />
              </IconButton>
            </Tooltip>
            <Tooltip title="Cancel">
              <IconButton
                aria-label={"refreshData"}
                size="small"
                onClick={this.cancelEditMode}
              >
                <CancelIcon fontSize="small" size="small" />
              </IconButton>
            </Tooltip>
          </>
        ) : (
          <>
            <Tooltip title="Edit Record">
              <IconButton
                aria-label={"refreshData"}
                size="small"
                onClick={() => {
                  this.setState({
                    selectedEditRowId: {
                      key: "buildingClassId",
                      value: cellInfo.buildingClassId,
                    },
                    isInAddMode: false,
                    updateMasterData: cellInfo,
                  });
                }}
              >
                <EditIcon fontSize="small" size="small" />
              </IconButton>
            </Tooltip>
            {/*<Tooltip title="Edit Record">
		  <IconButton
			aria-label={'refreshData'}
			size="small"
			onClick={() => {
			  this.deleteRecord(cellInfo);
			}}
		  >
			<DeleteIcon fontSize="small" size="small" />
		  </IconButton>
		</Tooltip>*/}
          </>
        )}
      </>
    );
  };

  handleTableEditChange = (value, fieldName, row, addMode) => {
    const param = this.state.updateMasterData;
    if (fieldName === "buildingClass") {
      param[fieldName] = value || [];
    }

    this.setState({ updateMasterData: param });
    this.forceUpdate();
  };

  AddNewRecord = () => {
    if (this.state.isInAddMode === true) {
      ShowToast("You can add one row at a time!", toastType.WARNING, 5000, 500);
      return false;
    }

    const rowNew = {
      buildingClassId: -1,
      buildingClass: null,
      modifiedBy: "",
      modifiedDate: moment().format("YYYY-MM-DD"),
      statusId: 1,
    };
    this.setState({
      isInAddMode: true,
      selectedEditRowId: { key: "buildingClassId", value: -1 },
      updateMasterData: rowNew,
    });
  };

  render() {
    const { buildingMasterData } = this.state;

    return (
      <>
        {this.state.showWarningMessage && (
          <ConfirmDialog
            IsOpen={this.state.showWarningMessage}
            Message={this.state.confirmMessage}
            OnHandelClick={(isValid) => {
              this.onClickHandle(isValid);
            }}
            AgreeText="Yes"
            DisAgreeText="No"
          ></ConfirmDialog>
        )}
        <div>Configure Building Class</div>

        {buildingMasterData && (
          <GridTable
            columns={UpdateColumnWithConfiguration(
              buildingClassMasterColumns,
              this.state.configuration,
              []
            )}
            data={buildingMasterData}
            renderActionColumn={this.renderActionColumn}
            selectedEditRowId={this.state.selectedEditRowId}
            isInAddMode={this.state.isInAddMode}
            EditSource={[]}
            handleTableEditChange={this.handleTableEditChange}
            updateData={this.state.updateMasterData}
            AddNewRecord={{
              action: this.AddNewRecord,
              title: "Add New Building Class",
              visible: true,
            }}
            reload={this.state.reloadTable}
          ></GridTable>
        )}
      </>
    );
  }
}
